// Navigation state only: never copy credentials, reset tokens or email into URLs.
export function safeReturnPath(value, fallback = null) {
  if (typeof value !== 'string' || !value.startsWith('/')) return fallback;
  // Check both the raw and encoded forms. Browsers normalize backslashes as
  // slashes in special URLs; neither protocol-relative nor control-char paths
  // are a valid post-auth destination.
  let decoded = value;
  try {
    for (let pass = 0; pass < 3; pass += 1) {
      if (!decoded.startsWith('/') || decoded.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(decoded)) return fallback;
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    }
    if (decoded.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(decoded)) return fallback;
    const parsed = new URL(value, 'https://henosis.invalid');
    if (parsed.origin !== 'https://henosis.invalid') return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_) {
    return fallback;
  }
}

export function authReturnTo(location, fallback = '/chat') {
  const params = new URLSearchParams(location?.search || '');
  // Existing activation intent wins over the normal chat fallback.
  if (params.get('intent') === 'activate') return '/activate';
  return safeReturnPath(params.get('returnTo'))
    || safeReturnPath(location?.state?.returnUrl)
    || fallback;
}

export function authRoute(path, location, includeDefault = false) {
  const destination = authReturnTo(location, includeDefault ? '/chat' : null);
  return destination ? `${path}?returnTo=${encodeURIComponent(destination)}` : path;
}

export function authErrorMessage(data, fallback) {
  if (typeof data?.detail === 'string' && data.detail.trim()) return data.detail;
  if (Array.isArray(data?.detail)) {
    const messages = data.detail.map(item => typeof item?.msg === 'string' ? item.msg : '').filter(Boolean);
    if (messages.length) return messages.join('; ');
  }
  if (typeof data?.error === 'string' && data.error.trim()) return data.error;
  if (data?.error && typeof data.error === 'object') {
    const messages = Object.entries(data.error).map(([field, value]) => {
      const text = Array.isArray(value) ? value.join(', ') : String(value ?? '');
      return text ? `${field}: ${text}` : '';
    }).filter(Boolean);
    if (messages.length) return messages.join('; ');
  }
  return fallback;
}
